import Cookies from 'js-cookie';
import {urls} from '../endPoint';
import {api} from '../http';
import {cart} from '../redux/reducers/cartSlice';
import { colors, posts } from '../redux/reducers/globalSlice';
import {order} from '../redux/reducers/orderSlice';
import {services} from '../redux/reducers/serviceSlice';
import { addresses, SET_LOGGED_IN, user, workerOffs } from '../redux/reducers/userSlice';
import {SET_LOADING} from '../redux/reducers/loadingSlice';

export const initialApis = async (dispatch: any, navigate: any) => {
  dispatch(SET_LOADING(true));
  await Promise.all([
    dispatch(services()),
  ]);
  if (Cookies.get('worker-token')) {
    const res = await api(urls.getUser, {}, true);
    if (res.code == 200) {
      dispatch(SET_LOGGED_IN(true))
      await userApis(dispatch);
      dispatch(user(res.data))
    } else {
      // Cookies.remove('worker-token');
      navigate('/login')
    }
  }else{
    navigate('/login')
  }
  dispatch(SET_LOADING(false));
  // dispatch(colors())

};
export const userApis = async (dispatch: any) => {
  await Promise.all([
    dispatch(order()),
    dispatch(workerOffs()),
    // dispatch(addresses()),
  ]);
};

export const logout = (dispatch: any) => {
  dispatch(SET_LOGGED_IN(false));
  Cookies.remove('worker-token');
  // window.location.reload();
};
